// Portaled controls live under document.body, not inside their owning drawer.
// Keep their layer above workspace drawers even when a caller adds old z-* classes.
export const OVERLAY_LAYERS = Object.freeze({
  filterBackdrop: 120,
  filterDrawer: 130,
  popup: 200,
});
